import React from "react";
import { Box, Typography, IconButton, Tooltip, Collapse } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function UnreadCountBadge({ count }) {
  const unread = Number(count) || 0;
  if (unread <= 0) return null;
  return (
    <Box
      aria-label={`${unread} não lidas`}
      sx={{
        minWidth: 20,
        height: 20,
        px: 0.75,
        borderRadius: 10,
        bgcolor: "primary.main",
        color: "primary.contrastText",
        fontSize: "0.7rem",
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {unread > 99 ? "99+" : unread}
    </Box>
  );
}

const SidebarSection = ({
  title,
  count,
  unreadCount = 0,
  collapsed,
  onToggleCollapse,
  onAdd,
  addLabel,
  showAdd = false,
  children,
}) => (
  <Box sx={{ mb: 0.5 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.25,
        px: 1,
        py: 0.5,
        minHeight: 36,
      }}
    >
      <IconButton
        size="small"
        onClick={onToggleCollapse}
        aria-label={collapsed ? "Expandir" : "Recolher"}
        sx={{ color: "text.primary", opacity: 0.72 }}
      >
        {collapsed ? <ChevronRightIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </IconButton>

      <Typography
        component="button"
        type="button"
        onClick={onToggleCollapse}
        sx={{
          flex: 1,
          textAlign: "left",
          border: 0,
          background: "none",
          cursor: "pointer",
          p: 0,
          fontSize: "0.7rem",
          fontWeight: collapsed && unreadCount > 0 ? 800 : 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "text.primary",
          opacity: collapsed && unreadCount > 0 ? 1 : 0.72,
          "&:hover": { opacity: 1 },
        }}
      >
        {title}
        {count > 0 ? ` (${count})` : ""}
      </Typography>

      {collapsed ? <UnreadCountBadge count={unreadCount} /> : null}

      {showAdd ? (
        <Tooltip title={addLabel}>
          <IconButton
            size="small"
            color="primary"
            onClick={onAdd}
            aria-label={addLabel}
            sx={{ mr: 0.5 }}
          >
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>

    <Collapse in={!collapsed}>{children}</Collapse>
  </Box>
);

export default SidebarSection;
